import React, { useCallback, useEffect, useState } from 'react'
import { Table } from 'reactstrap';
import { raiseClaimService } from '../../services';
import { formatDate } from '../../helpers/common';
import Loading from '../common/Loading';
import {
    Button, Modal, ModalBody, ModalHeader, ModalFooter
} from 'reactstrap';


const CommonCommentModal = ({ openModal, handleClose, user, commentList, commentedUserType }) => {

    return (
        <Modal isOpen={openModal} toggle={() => handleClose('ADD')} size='xl'>
            <ModalHeader toggle={() => handleClose('ADD')}>Comments by {commentedUserType}</ModalHeader>
            <ModalBody>
                <div className='fieldArrayBox'>
                    {commentList?.length > 0 ?
                        <Table>
                            <thead>
                                <tr>
                                    <th >Sl No.</th>
                                    {/* <th >Date</th> */}
                                    <th >Commenter</th>
                                    {/* <th >Role</th> */}
                                    <th >Comments</th>
                                </tr>
                            </thead>
                            <tbody>
                                {commentList?.map(({
                                    commentId,
                                    commentDescription,
                                    createdDate,
                                    userName,
                                    userEmail,
                                    userRole
                                }, index) => {
                                    // const [commenter, role] = remarksBy ? remarksBy.match(/(.*) \((.*)\)/).slice(1, 3) : ["--", "--"];
                                    return (
                                        <tr key={commentId}>
                                            <td>{index + 1}</td>
                                            {/* <td>{formatDate(createdDate) || "--"}</td> */}
                                            <td>{userName || "--"}</td>
                                            {/* <td>{userRole || "--"}</td> */}
                                            <td>{commentDescription || "--"}</td>
                                        </tr>
                                    );

                                })}
                            </tbody>
                        </Table> : <p className='no-data text-center'>No Comments Found</p>}
                    {/* <div className='fieldArrayColumnUl_outer' style={{ background: "rgb(239,239,239)" }}>
                        <textarea
                            name="newComment"
                            placeholder="Enter Your Comments Here.."
                            className="form-control"
                            value={newComment}
                            onChange={(event) => setNewComment(event.target.value)}
                        />
                        <div style={{ display: "flex", justifyContent: "flex-end" }}>
                            <button type="button" className="btn btn-primary mt-2" disabled={!newComment.trim() || isSubmitted} onClick={addComments}>
                                Add Comments
                            </button>
                        </div>
                    </div> */}
                </div>
            </ModalBody>
        </Modal >
    )
}

export default CommonCommentModal
